export enum AddressType {
  Primary = 'Primary',
  Billing = 'Billing',
}
